import WebSocketStore from 'core/classes/services/WebSocketStore'

import { IPartnerTerritory } from '../../models/partnerTerritoryModels'

class OnboardingPartnerTerritoryApi {
  public getPartnerTerritory = async () => {
    const response = await WebSocketStore.get('onboarding').call<IPartnerTerritory>({
      service: 'partnerTerritory',
      action: 'getPartnerTerritory',
      withoutTokenRefresh: true,
      isAuth: true,
    })

    return response.data
  }
}

export const onboardingPartnerTerritoryApi = new OnboardingPartnerTerritoryApi()
